var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66446",
    "data-name": "Group 66446",
    transform: "translate(48.407 -0.322) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3404",
    "data-name": "Ellipse 3404",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0.322 0.407)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    transform: "translate(27.896 18.316) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23854",
    "data-name": "Path 23854",
    d: "M6.624,7.552a.925.925,0,0,1-.656-.272l-5.7-5.7A.928.928,0,0,1,1.584.272L6.624,5.313,11.665.272a.928.928,0,1,1,1.312,1.312l-5.7,5.7A.925.925,0,0,1,6.624,7.552Z",
    transform: "translate(0 0)",
    fill: "#244158"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow.ecf75f821d2173ea6369344891b30a5d.svg";